import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    textField5: state.components.contactUsForm.fieldValues["textField5"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface Field1Styles {
    field1TextField?: TextFieldPresentationProps;
}

export const field1Styles: Field1Styles = {};

const styles = field1Styles;

const TextField5: React.FC<Props> = ({ fields, textField5, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [field1ErrorMessage, setField1ErrorMessage] = React.useState("");

    React.useEffect(() => {
        setFieldValue({ key: "textField5Label", value: fields.label });
    }, [fields.label]);

    React.useEffect(() => {
        contactFormContext.validators.field1 = validateField1;
        if (typeof textField5 !== "undefined") {
            validateField1();
        }
    }, [textField5]);

    React.useEffect(() => {
        contactFormContext.validators.field1 = validateField1;
    }, [isRequired]);

    const validateField1 = () => {
        const errorMessage = isRequired && !textField5 ? (siteMessage("Field_Required", label) as string) : "";
        setField1ErrorMessage(errorMessage);
        return !errorMessage;
    };

    const field1ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "textField5", value: event.target.value });
    };

    return (
        <TextField
            {...styles.field1TextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={textField5 || ""}
            error={field1ErrorMessage}
            onChange={field1ChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TextField5),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Text Field 5",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter a value",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
